import React, { useState } from 'react';
import { refreshOrderSizes } from '@/hooks/useOrderSizes';

// Retrying this read does not claim to download or replace a desktop catalog.
export default function SizeChoicesUnavailable() {
  const [pending, setPending] = useState(false);
  const retry = async () => {
    setPending(true);
    try { await refreshOrderSizes(); } finally { setPending(false); }
  };
  return (
    <p className="mt-1 text-xs text-stone-500" data-testid="size-choices-unavailable">
      Size choices unavailable. You can save without changing the size.
      {typeof navigator !== 'undefined' && navigator.onLine !== false && (
        <button type="button" className="ml-1 underline" disabled={pending} onClick={retry}>
          {pending ? 'Checking sizes…' : 'Retry size choices'}
        </button>
      )}
    </p>
  );
}
